export default {"src":"/_next/static/media/pin.2adc2d38.svg","height":15,"width":12,"blurWidth":0,"blurHeight":0};